import FilterRequest from '../../../../../Spirit/Common/Extensions/Models/FilterRequest';

export default class SearchFilterRequest extends FilterRequest {
	Name?: string = '';
	CategoryId?: number = null;
	constructor(obj?: Partial<SearchFilterRequest>) {
		super(obj);
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
